import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectionList, MatListOption } from '@angular/material/list';

@Component({
    selector: 'unite-income-source-input',
    templateUrl: './income-source-input.component.html',
    styleUrls: ['./income-source-input.component.scss'],
    imports: [MatSelectionList, ReactiveFormsModule, MatListOption, TranslateModule]
})
export class IncomeSourceInputComponent {

  control = input<FormControl>();

}
